import { Box, Typography } from "@mui/material";
import TasksEditor from "@/pages/tasks/TasksEditor";

export const TASKS_PANEL_WIDTH = 400;

interface DealTasksPanelProps {
  dealId: number | null;
  highlightTaskId?: number | null;
}

export const DealTasksPanel = ({
  dealId,
  highlightTaskId,
}: DealTasksPanelProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        backgroundColor: "#f2f5f9",
      }}
    >
      <Box sx={{ flex: 1, overflow: "auto", minHeight: 0, backgroundColor: "#f2f5f9", p: 2 }}>
        {dealId == null ? (
          <Typography color="text.secondary" variant="body2">
            Select a deal to view tasks.
          </Typography>
        ) : (
          <TasksEditor
            dealId={dealId}
            highlightTaskId={highlightTaskId}
          />
        )}
      </Box>
    </Box>
  );
};
